var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['hz-default-tooltip', _vm.theme, _vm.size],attrs:{"data-toggle":"tooltip","data-placement":_vm.position,"data-html":_vm.html,"title":_vm.title}},[_c('i',{class:['glyphicon', _vm.icon]})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56e54947","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/components/Tooltip.vue
// module id = 928
// module chunks = 1